import { API_DOMAIN } from 'constants/infograph';
import request from 'utils/request';

export type Icons8Params = {
  category: string;
  platform: string;
  limit: number;
  offset: number;
};

type Icons8IconData = {
  id: string;
  name: string;
  commonName: string;
  platform: string;
};

export type Icons8IconsApiResponse = {
  success: boolean;
  icons: Icons8IconData[];
  parameters: {
    amount: number;
    countAll: number;
    offset: number;
  };
};

// fetch api from
export const fetchE2Icons8Api = async (param: Icons8Params, token: string) => {
  const { category, platform, limit, offset } = param;

  let requestURL = `${API_DOMAIN}/searchIcons8?category=${category}&platform=${platform}&limit=${limit}&offset=${offset}`;

  const headers = new Headers({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  });

  return await request<Icons8IconsApiResponse>(requestURL, {
    method: 'GET',
    headers: Object.fromEntries(headers),
  });
};
